
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/items/new",
      function () {
        return require("private-next-pages/items/new.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/items/new"])
      });
    }
  